import request from "../request";
import Url from "../url/common";

const login = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.login + path, data, options);
};

export default {
  login,
};
